export enum CityTypeEnum {
  City = 1,
  Metropolitan = 2
}
